import { render, staticRenderFns } from "./menuCalibrationLab.vue?vue&type=template&id=33666532&scoped=true&"
import script from "./menuCalibrationLab.vue?vue&type=script&lang=js&"
export * from "./menuCalibrationLab.vue?vue&type=script&lang=js&"
import style0 from "./menuCalibrationLab.vue?vue&type=style&index=0&id=33666532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33666532",
  null
  
)

export default component.exports